import React, { useEffect, Component, useState } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import { Sidebar } from '../sidebar/Sidebar';
import Navbar from '../navbar/navbar';
import "./reveiwDetail.css";
import profile from "../images/profile.jpg";
import { getUserById } from '../../../Services/users.service';
import _ from 'lodash';
import { getReviewsByUserId } from '../../../Services/reviews.service';
import { editReview } from '../../../Services/reviews.service';


export const AdminReviewsUpdate = (props) => {

    const [showEditForm, setShowEditForm] = useState(false);
    const [businessData, setBusinessData] = useState(null)
    const [filteredList, setFilteredList] = useState([])
    const [searchValue, setSearchValue] = useState('')

    const handleCloseEdit = () => setShowEditForm(false);
    const handleShowEdit = () => setShowEditForm(true);
    if (!!props.location.businessData) {
        let _businessData = {}
        _businessData.businessId = props.location.businessData.businessId;
        _businessData.businessName = props.location.businessData.businessName;
        _businessData.totalReviews = props.location.businessData.totalReviews;
        let reviews = props.location.businessData.reviews
        //console.log(reviews);
        _.forEach(reviews, (r) => {
            getUserById(r.userId).then(u => {
                if (r.userId == u[0].userId) {
                    r.name = u[0].name;
                    r.imageUrl = u[0].userImage
                    return r;
                }
            })
        })

        setTimeout(() => {
            _businessData.reviews = reviews;
            setBusinessData(_businessData)
            //console.log(_businessData);

        }, 1000);


    }
    else if (!!props.location.userId) {
        console.log(props.location.userId);

        getReviewsByUserId(props.location.userId).then(u => {
            console.log(u);
            let _data = {};
            _data.totalReviews = u.length;
            _data.businessName = '';
            _data.reviews = u
            setBusinessData(_data)
        })
    }
    useEffect(() => {

    }, []);

    function onValueChange(event, item) {
        //console.log('here',businessData,event.target.value);
        var data = businessData;
        //console.log(data);
        _.forEach(data?.reviews, (value) => {
            value.status = event.target.value;
        });
        setBusinessData(data);
        console.log('----------', businessData);
        //item.status=event.target.value;
    }
    function updateReview() {
        var data = businessData;
        //data.businessId=businessData.reviewId;
        console.log(data);
        editReview(data);
    }
    // useEffect(() => {
    //     console.log('Do something after counter has changed', businessData);
    //  }, [businessData]);

    let handleSearchValue = (value) => {
        console.log(value);
        let search = value;
        search = search.trim();
        search = search.toLowerCase();

        if (!!search) {
            setSearchValue(search)
            let localList = [];
            _.forEach(businessData?.reviews, (value) => {

                if (_.includes((value.name).toLowerCase(), search) || _.includes((value.description).toLowerCase(), search)) {
                    localList.push(value);
                }

            });
            setFilteredList(localList)
        }
        else {
            setSearchValue(search)
            let localList = [];
            setFilteredList(localList)
        }
    }

    return (
        <>

            {/* Page Wrapper */}
            <div id="wrapper">
                {/* Sidebar */}
                <Sidebar />
                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Navbar setValue={handleSearchValue} />
                        <div className="container-fluid">
                            <section className="adminReDetailPage">
                                {/* Content Row */}
                                {businessData ?
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                <h2 className="theme-color">Reviews</h2>

                                                <p className="numReview">{businessData?.totalReviews} Reviews {businessData?.businessName ? `of ${businessData?.businessName}` : null}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {
                                                !!searchValue ?
                                                    filteredList.length > 0 ?
                                                        filteredList.map((item) => {
                                                            //console.log(item.status);
                                                            return (
                                                                <div className="col-12 mb-3">
                                                                    <div className="detailCard">
                                                                        <div className="profileDiv">
                                                                            <div className="d-flex ai-center">
                                                                                <img src={item.imageUrl ? item.imageUrl : profile} alt="profile" className="prImg" />
                                                                                <p className="prName">{item.name ? item.name : null}</p>
                                                                                <span className="time">{item.dateAdded}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <p className="reviewText">{item.description}</p>
                                                                        </div>
                                                                        <div className="row form-check text-center">
                                                                            <label>Status</label> <br />
                                                                            <input className="form-check-input" type="radio" value="Pending" name="status" checked={item.status === 'Pending'} onChange={(e) => onValueChange(e, item)} /> Pending <br />
                                                                            <input className="form-check-input" type="radio" value="Accepted" checked={item.status === 'Accepted'} name="status" onChange={(e) => onValueChange(e, item)} /> Accepted <br />
                                                                            <input className="form-check-input" type="radio" value="Rejected" checked={item.status === 'Rejected'} name="status" onChange={(e) => onValueChange(e, item)} />Rejected <br /><br />
                                                                            <Button className="btn-success" onClick={() => updateReview()}  >Update Status</Button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            )
                                                        }
                                                        )
                                                        :
                                                        null
                                                    :
                                                    businessData?.reviews.length > 0 ?
                                                        businessData?.reviews.map((item) => {
                                                            //console.log(item.status);
                                                            return (
                                                                <div className="col-12 mb-3">
                                                                    <div className="detailCard">
                                                                        <div className="profileDiv">
                                                                            <div className="d-flex ai-center">
                                                                                <img src={item.imageUrl ? item.imageUrl : profile} alt="profile" className="prImg" />
                                                                                <p className="prName">{item.name ? item.name : null}</p>
                                                                                <span className="time">{item.dateAdded}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <p className="reviewText">{item.description}</p>
                                                                        </div>
                                                                        <div className="row form-check text-center">
                                                                            <label>Status</label> <br />
                                                                            <input className="form-check-input" type="radio" value="Pending" name="status" checked={item.status === 'Pending'} onChange={(e) => onValueChange(e, item)} /> Pending <br />
                                                                            <input className="form-check-input" type="radio" value="Accepted" checked={item.status === 'Accepted'} name="status" onChange={(e) => onValueChange(e, item)} /> Accepted <br />
                                                                            <input className="form-check-input" type="radio" value="Rejected" checked={item.status === 'Rejected'} name="status" onChange={(e) => onValueChange(e, item)} />Rejected <br /><br />
                                                                            <Button className="btn-success" onClick={() => updateReview()}>Update Status</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        null
                                            }
                                        </div>
                                    </>
                                    :
                                    null
                                }
                            </section>

                        </div>
                        {/* /.container-fluid */}

                    </div>
                </div>
            </div>

        </>
    )
}

